module.exports = __webpack_public_path__ + "img/5.939c6afb.png";